export const routes = {
  endpoints: {
    aiAgents: '/ai-agents',
    aiAgentUpdate: '/ai-agents/:id',
    aiAgentPublish: '/ai-agents/:id/publish',
    aiAgentLogs: '/ai-agents/:id/logs',
    aiAgentAttestation: '/ai-agents/:id/attestation',
    aiAgentStatus: '/ai-agents/:id/status',
    aiAgentStatusUpdate: '/ai-agents/:id/:action',
    aiAgentDelete: '/ai-agents/:id',
    aiAgentDraftCreate: '/ai-agents',
    projects: '/projects',
    teams: '/teams',
    subscriptions: '/subscriptions',
    subscriptionUpdate: '/subscriptions/:id',
    subscriptionCheckout: '/subscriptions/checkout',
    subscriptionUpdateQuantity: '/subscriptions/:id/quantity',
    plans: '/plans',
    tokens: '/tokens',
    tokenDelete: '/tokens/:id',
    aiAgentMessage: '/ai-agents/:id/api/:elizaId/message',
    aiAgentMessageV2: '/ai-agents/:id/api/api/agents/:elizaId/message',
    proxyAiAgents: '/ai-agents/:id/api/agents',
    proxyAiAgentsV2: '/ai-agents/:id/api/api/agents',
    elizaOsVersions: '/machines/images/eliza',
    llmModels: '/llm/models',
    credits: '/credits',
    createCreditsCheckout: '/credits/checkout',
  },
  agentsDashboardPage: '/projects/:projectId/agents/',
};

export const pages = {
  guides: {
    getStarted: 'https://fleek.xyz/guides/eliza-guide/',
    characterfile: {
      fromScratch:
        'https://fleek.xyz/guides/eliza-guide/#manually-enter-agent-details',
      template:
        'https://fleek.xyz/guides/eliza-guide/#use-a-predefined-template',
    },
  },
  supportPath: '/support',
};

export const agentChat = {
  messageSenderUserValue: '[user]',
  messageSenderUserLabel: 'You',
};

export const featureFlags = {
  agentCreationViaChat: true,
};

export const PRODUCT_NAME_AI_AGENT_PLAN_TEE = 'ai agent';
export const PRODUCT_NAME_AI_AGENT_PLAN_STANDARD = 'ai agent (standard)';

// TODO: The following URL should be exported from the package agents-chatbox-widget instead of hard-typing it here
// https://linear.app/fleekxyz/issue/PLAT-2679/agents-chat-widget-agents-ui-script-url-must-be-exported-from-agents
export const chatWidget = {
  scriptUrl:
    'https://unpkg.com/@fleek-platform/agents-chatbox-widget@latest/dist/chatbox.min.js',
};
